import IconButton from '../IconButton';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { ContentContainer, TitleContainer } from './styles';
import './styles.css';

export default function CollapsableContainer({ children, defaultCollapse, title }) {
  const [collapsed, setCollapsed] = useState(defaultCollapse);

  const toggleCollapse = useCallback(() => {
    setCollapsed((collapsed) => !collapsed);
  }, []);

  return <>
    <TitleContainer>
      <h3 onClick={toggleCollapse}>{title}</h3>
      <IconButton
        iconSize={16}
        className={classnames('icon-toggle', collapsed ? 'collapsed' : 'collapse')}
        onClick={toggleCollapse}
        src="/assets/left-arrow.svg"
      />
    </TitleContainer>
    <br/>
    <ContentContainer className={collapsed ? 'collapsed' : 'collapse'}>
      {children}
    </ContentContainer>
    <br/>
  </>;
}
